import { createSlice } from '@reduxjs/toolkit';

// UI slice for managing UI state
const uiSlice = createSlice({
  name: 'ui',
  initialState: {
    notifications: [],
    sidebarOpen: true,
    activeTab: 'dashboard',
    loading: {
      global: false,
      dashboard: false,
      subscriptions: false,
      transactions: false,
      deliveries: false,
      account: false,
    },
    errors: {
      global: null,
      dashboard: null,
      subscriptions: null,
      transactions: null,
      deliveries: null,
      account: null,
    },
    modals: {
      newSubscription: false,
      cancelSubscription: false,
      confirmDelivery: false,
      editProfile: false,
    },
  },
  reducers: {
    setLoading: (state, action) => {
      const { section, isLoading } = action.payload;
      state.loading[section] = isLoading;
    },
    setError: (state, action) => {
      const { section, error } = action.payload;
      state.errors[section] = error;
    },
    clearError: (state, action) => {
      const section = action.payload;
      state.errors[section] = null;
    },
    toggleSidebar: (state) => {
      state.sidebarOpen = !state.sidebarOpen;
    },
    setActiveTab: (state, action) => {
      state.activeTab = action.payload;
    },
    openModal: (state, action) => {
      state.modals[action.payload] = true;
    },
    closeModal: (state, action) => {
      state.modals[action.payload] = false;
    },
    addNotification: (state, action) => {
      state.notifications.push({
        id: Date.now(),
        ...action.payload,
      });
    },
    removeNotification: (state, action) => {
      state.notifications = state.notifications.filter(
        (notification) => notification.id !== action.payload
      );
    },
    clearNotifications: (state) => {
      state.notifications = [];
    },
  },
});

export const {
  setLoading,
  setError,
  clearError,
  toggleSidebar,
  setActiveTab,
  openModal,
  closeModal,
  addNotification,
  removeNotification,
  clearNotifications,
} = uiSlice.actions;

export default uiSlice.reducer;
